export default __webpack_public_path__ + "static/media/light-mode.f681ac14.svg";